import { render, staticRenderFns } from "./PurchaseInsurance.vue?vue&type=template&id=53b32968&scoped=true"
import script from "./PurchaseInsurance.vue?vue&type=script&lang=js"
export * from "./PurchaseInsurance.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInsurance.vue?vue&type=style&index=0&id=53b32968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b32968",
  null
  
)

export default component.exports